import gql from 'graphql-tag';

export default gql`
  subscription onUpdateArtwork($userid: ID!) {
    onUpdateArtwork(userid: $userid) {
      id
    }
  }
`;
